import { render, staticRenderFns } from "./FormClearing.vue?vue&type=template&id=5b792ae0&scoped=true"
import script from "./FormClearing.vue?vue&type=script&lang=js"
export * from "./FormClearing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b792ae0",
  null
  
)

export default component.exports